import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { ErrorService } from './modules/shared/services/error-service';
import { environment } from 'environments/environment';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) {}

    errorService = this.injector.get(ErrorService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if ([401, 403].includes(error.status)) {
                    //should we log this? auth-gaurd handles logout of user, so no need to do so here.
                } else {
                    if (environment.production) {
                        console.error('Unexpected server error.');
                    } else {
                        //dev environment
                        console.error(error);
                    }
                }
                return throwError(error);
            })
        );
    }
}
